"use strict";
import ApiService from "@/core/services/api.service";

const baseURL = "Companies";

export default {
  getAllCompany() {
    return new Promise(resolve => {
      ApiService.get(`${baseURL}/GetAllCompany`).then(({ data }) => {
        resolve(data);
      });
    });
  },
  saveCompany(payload) {
    return new Promise(resolve => {
      ApiService.post(`${baseURL}/SaveCompany`, payload).result.then(
        ({ data }) => {
          resolve(data);
        }
      );
    });
  },
  companyRecInfo(companyId) {
    return new Promise(resolve => {
      ApiService.get(
        `${baseURL}/CompanyRecInfo`,
        `?companyID=${companyId}`
      ).then(({ data }) => {
        resolve(data);
      });
    });
  },
  companyDelete(companyId) {
    return new Promise(resolve => {
      ApiService.delete(`${baseURL}/CompanyDelete?companyID=${companyId}`).then(
        ({ data }) => {
          resolve(data);
        }
      );
    });
  }
};
